import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs } from 'vue';

/**
 * Properties
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'QBtnClose',
  props: {
  disable: { type: Boolean, required: false, default: false },
  addedClass: { type: String, required: false },
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

// Vendor
const props = __props;
const { disable, addedClass } = toRefs(props);

/**
 * Events
 */
const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
    dense: "",
    flat: "",
    icon: "close",
    class: _normalizeClass([_unref(addedClass), 'set-outline']),
    disable: _unref(disable),
    title: "Fermer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, null, 8 /* PROPS */, ["class", "disable"])), [
    [_directive_close_popup]
  ])
}
}

})